
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/maximize-3","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#697485"}},[_c('path',{attrs:{"d":"M12.5 18.959h-5c-2.309 0-3.872-.488-4.921-1.537S1.042 14.809 1.042 12.5v-5c0-2.308.488-3.872 1.537-4.921S5.192 1.042 7.5 1.042h5c2.309 0 3.872.488 4.921 1.537s1.538 2.613 1.538 4.921v5c0 2.309-.488 3.872-1.537 4.921s-2.613 1.538-4.922 1.538zm-5-16.667c-1.955 0-3.238.372-4.037 1.171S2.292 5.545 2.292 7.5v5c0 1.955.372 3.238 1.171 4.037s2.082 1.171 4.037 1.171h5c1.955 0 3.238-.372 4.037-1.171s1.171-2.082 1.171-4.037v-5c0-1.955-.372-3.238-1.171-4.037S14.456 2.292 12.5 2.292z"}}),_c('g',{attrs:{"data-name":"Group 665","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M5 15.625a.623.623 0 01-.442-.183.625.625 0 010-.884l10-10a.625.625 0 01.884 0 .625.625 0 010 .884l-10 10a.623.623 0 01-.442.183z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M15 8.958a.625.625 0 01-.625-.625V5.625h-2.708A.625.625 0 0111.042 5a.625.625 0 01.625-.625H15a.625.625 0 01.625.625v3.333a.625.625 0 01-.625.625zM8.333 15.625H5A.625.625 0 014.375 15v-3.333A.625.625 0 015 11.042a.625.625 0 01.625.625v2.708h2.708a.625.625 0 010 1.25z"}})])])])
          )
        }
      }
    